import { createSlice } from '@reduxjs/toolkit';
import { baseOnboardingUrl } from './hooks';

const initialState = {
  // Modal-specific state
  baseUrl: baseOnboardingUrl,
  
  // Stage checklist data
  stageCheckList: {
    "short": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "sentence that shows up on checklist"
    },
    "codes": {
      "workflows": ["voip", "dso"],
      "description": "these will be hard-coded in the UI"
    },
    "corresponding": {
      "workflows": ["non-voip", "dso"],
      "description": "they are just there to serve as a reference"
    }
  },
  
  // Loading and error states
  loading: false,
  error: null,
  
  // Success state
  success: false
};

const signedDateSlice = createSlice({
  name: 'signedDate',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const {
  clearError,
  clearSuccess,
  setLoading
} = signedDateSlice.actions;

// Selectors
export const selectBaseUrl = (state) => state.signedDate.baseUrl;
export const selectStageCheckList = (state) => state.signedDate.stageCheckList;
export const selectLoading = (state) => state.signedDate.loading;
export const selectError = (state) => state.signedDate.error;
export const selectSuccess = (state) => state.signedDate.success;

export default signedDateSlice.reducer;
